import { UseQueryResult } from "@tanstack/react-query";
import { GroupsListApiResponse } from "../../../types/api.types";
import { queryKeys } from "../../queryKeys";
import { useAppQuery, UseAppQueryOptions } from "../../useAppQuery";

/**
 * Hook to fetch user's groups list
 * Replaces the GroupsList.get() static method pattern
 *
 * @example
 * const { data, isLoading, error } = useGroups();
 * const groups = data?.groups || [];
 */
export function useGroups(
  options?: Omit<UseAppQueryOptions<GroupsListApiResponse, Error>, "queryKey" | "config">
): UseQueryResult<GroupsListApiResponse, Error> {
  return useAppQuery<GroupsListApiResponse, Error>("/MyGroup", {
    ...options,
    queryKey: queryKeys.groups.list()
  });
}
